import(/* webpackMode: "eager" */ "/workspace/src/app/features/page.tsx");
